import { Investor, InvestorApplication } from '../types/investor';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5555';

/**
 * Apply to become an investor
 */
export async function applyAsInvestor(
  userId: string,
  email: string,
  application: InvestorApplication
): Promise<{ message: string; investor: Investor }> {
  const response = await fetch(`${API_BASE}/api/investors/apply`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      userId,
      email,
      ...application,
    }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Failed to submit application');
  }
  return data;
}
